import React from "react";
import PropTypes from "prop-types";
import styled, { css, keyframes } from "styled-components";
import { easingPropType } from "../../utils/propTypes";

var fadeAnimation = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);

var animation = function animation(props) {
  return css(["animation:", "ms ", " 0s 1 ", ";"], props.fadeDuration, props.fadeEasing, fadeAnimation);
};

// prettier-ignore
var Base = styled("div").withConfig({
  displayName: "Tooltip__Base",
  componentId: "sc-19cbsjq-0"
})(["position:absolute;", ";", ";"], function (props) {
  return props.fadeDuration && props.fadeDuration > 0 && animation(props);
}, function (props) {
  return props.zIndex && "z-index: " + props.zIndex + ";";
});

var Top = styled(Base).withConfig({
  displayName: "Tooltip__Top",
  componentId: "sc-19cbsjq-1"
})(["bottom:100%;left:50%;transform:translateX(-50%);margin-bottom:", "px;"], function (props) {
  return props.offset;
});

var Bottom = styled(Base).withConfig({
  displayName: "Tooltip__Bottom",
  componentId: "sc-19cbsjq-2"
})(["top:100%;left:50%;transform:translateX(-50%);margin-top:", "px;"], function (props) {
  return props.offset;
});

var Left = styled(Base).withConfig({
  displayName: "Tooltip__Left",
  componentId: "sc-19cbsjq-3"
})(["right:100%;top:50%;transform:translateY(-50%);margin-right:", "px;"], function (props) {
  return props.offset;
});

var Right = styled(Base).withConfig({
  displayName: "Tooltip__Right",
  componentId: "sc-19cbsjq-4"
})(["left:100%;top:50%;transform:translateY(-50%);margin-left:", "px;"], function (props) {
  return props.offset;
});

var tooltips = {
  left: Left,
  top: Top,
  right: Right,
  bottom: Bottom
};

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      offset = _ref.offset,
      open = _ref.open,
      placement = _ref.placement,
      zIndex = _ref.zIndex,
      fadeDuration = _ref.fadeDuration,
      fadeEasing = _ref.fadeEasing;

  var Component = tooltips[placement] || tooltips.top;
  return open && React.createElement(
    Component,
    {
      offset: offset,
      zIndex: zIndex,
      fadeDuration: fadeDuration,
      fadeEasing: fadeEasing
    },
    children
  );
};

Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any.isRequired,
  offset: PropTypes.number,
  open: PropTypes.bool,
  placement: PropTypes.string,
  zIndex: PropTypes.number,
  fadeEasing: easingPropType,
  fadeDuration: PropTypes.number
} : {};

export default Tooltip;